import { getQSVar, getTotalAddOnsPrice } from '../utils';
import { IAddOn, IGlassesPackage } from '../types';

export function getPricingDetails(
    selectedPackage: IGlassesPackage,
    addOns: IAddOn[] | undefined
) {
    const framePrice = Number(getQSVar('price')) || 0;
    const addOnsPrice = addOns ? getTotalAddOnsPrice(addOns) : 0;
    const glassesPrice = selectedPackage.priceInt;
    const subTotal = framePrice + glassesPrice + addOnsPrice;
    const discount = 0;
    const total = subTotal - discount;

    return {
        framePrice,
        glassesPrice,
        discount,
        subTotal,
        total,
    };
}
